// ---------------------------------------------
// 🧩 Register GSAP Plugins
// ---------------------------------------------
gsap.registerPlugin(ScrollTrigger, SplitText);

// ---------------------------------------------
// 🌀 Imports
// ---------------------------------------------
import { lenisScroll } from './modules/lenis.js';
import { anchorScroll } from './modules/anchorScroll.js';
import { initializeFlickity } from './modules/flickity.js';
import { initializeParallaxFooter } from './modules/parallaxFooter.js';
import { initializeParallaxImage } from './modules/parallaxImage.js';
import { initializeTextReveal } from './modules/textReveal.js';
import blockFadeUp from './modules/blockFadeUp.js';
import { initializeMobileNav } from './modules/mobileNav.js';
import { initializeMobileFilterMenu } from './modules/mobileFilterMenu.js';
import { initializeLogoCarousel } from './modules/logoCarousel.js';
import { paginationScroll } from './modules/paginationScroll.js';
import { applyButton } from './modules/applyButton.js';
import { subMenu } from './modules/subMenu.js';
import { teamMemberModal } from './modules/teamMemberModal.js';
import { teamMemberFilters } from './modules/teamMemberFilters.js';
import { initializeAccordions } from './modules/accordion.js';
import { initializeHighlightText, introUsps } from "./modules/introduction.js";



// ---------------------------------------------
// 🚀 Initialize Modules
// ---------------------------------------------
function initModules() {
    // Global
    lenisScroll();
    anchorScroll();
    blockFadeUp();

    // Components
    initializeFlickity();
    initializeMobileFilterMenu();
    initializeParallaxFooter();
    initializeParallaxImage();
    initializeTextReveal();
    initializeMobileNav();
    initializeLogoCarousel();
    paginationScroll();
    applyButton();
    subMenu();
    teamMemberModal();
    teamMemberFilters();
    initializeAccordions();
    initializeHighlightText();
    introUsps();

}

// ---------------------------------------------
// ⚡ DOM Ready
// ---------------------------------------------
document.addEventListener('DOMContentLoaded', initModules);
